import { Decoration, DecorationSet } from 'prosemirror-view';
import { Plugin } from 'prosemirror-state';
export const placeholderPlugin = new Plugin({
  state: {
    init() {
      return DecorationSet.empty;
    },
    apply(tr, set) {
      let newSet = set.map(tr.mapping, tr.doc);
      const action = tr.getMeta(this);
      if (action && action.add) {
        const widget = document.createElement('placeholder');
        const deco = Decoration.widget(action.add.pos, widget, {
          id: action.add.id
        });
        if (action.className) {
          widget.classList.add(action.className);
        }
        newSet = newSet.add(tr.doc, [deco]);
      } else if (action && action.remove) {
        newSet = newSet.remove(newSet.find(null, null, spec => spec.id === action.remove.id));
      }
      return newSet;
    }
  },
  props: {
    decorations(state) {
      return this.getState(state);
    }
  }
});
export default {
  name: 'placeholder',
  configure: () => ({
    plugin: placeholderPlugin,
    floatingToolbars: [],
    menuItems: []
  })
};